import { appRoutes } from 'router/routes';

export const isPasswordRecoveryPaths = history => {
  const path = history.location.pathname;
  return path === appRoutes.passwordResetPath() || path === appRoutes.passwordRecoveryPath();
};
